/**
 * Tutorial guidato della pagina Sito ecommerce → Avvisi.
 *
 * In alto i numeri del periodo e i prodotti più attesi, sotto l'elenco delle
 * richieste "avvisami quando torna disponibile" con il loro esito.
 */
const SCOPE = '[data-tour-scope="alerts"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createAlertsTourSteps() {
	return [
		{
			body: 'Qui arrivano le richieste dei clienti che hanno chiesto di essere avvisati quando un prodotto torna disponibile o quando il suo prezzo scende. Restano tutte nello storico, anche dopo l’invio dell’avviso.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Gli avvisi',
		},
		{
			body: 'Due schede: Torna disponibile raccoglie chi aspetta un prodotto esaurito, Prezzo in calo chi ha chiesto di sapere quando il prezzo scende (offerte comprese, come sul sito). Numeri, filtri ed export seguono la scheda aperta.',
			key: 'types',
			placement: 'bottom',
			target: at('types'),
			title: 'I due tipi di avviso',
		},
		{
			body: 'In attesa sono i clienti che aspettano ancora; Avvisi inviati quelli già avvisati. Convertiti conta chi ha ordinato il prodotto entro 30 giorni dall’avviso, e Conversione è la percentuale sugli avvisi inviati. I numeri seguono il periodo scelto nei filtri.',
			key: 'kpi',
			placement: 'bottom',
			target: at('kpi'),
			title: 'I numeri',
		},
		{
			body: 'I prodotti con più clienti in attesa: sono quelli da riassortire per primi.',
			key: 'top',
			placement: 'top',
			target: at('top'),
			title: 'Prodotti più attesi',
		},
		{
			body: 'Esporta in CSV o Excel le richieste filtrate: il file arriva per mail e nella campanella. La colonna del consenso newsletter dice a chi si possono mandare campagne marketing; agli altri l’email serve solo per l’avviso.',
			key: 'export',
			placement: 'left',
			target: at('export'),
			title: 'Esportare',
		},
		{
			body: 'La ricerca trova email, prodotto, SKU o EAN (da tre caratteri), i chip restringono per stato e le date per periodo della richiesta. Tutto resta nell’indirizzo.',
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Cercare e filtrare',
		},
		{
			body: 'Ogni riga è una richiesta: prodotto, email del cliente (con il chip Newsletter se ha dato il consenso), stato, quando è partito l’avviso e l’eventuale ordine.',
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: 'I tre pallini aprono il prodotto nel BO o sul sito, l’ordine se c’è, e annullano una richiesta ancora in attesa.',
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			missing: 'skip',
			title: 'Le azioni di una richiesta',
		},
	];
}
